import {
    Dialog,
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Box
} from "@mui/material";
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Shared full-screen dialog with consistent AppBar and close button placement.
 * Use for Dictionary Editor, Phrases Editor, and similar dialogs.
 */
const FullScreenDialog = ({ 
    open, 
    onClose, 
    title, 
    children, 
    actions = null,
    helpAction = null 
}) => {
    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6">
                        {title}
                    </Typography>
                    {actions && (
                        <Box sx={{ mr: 2 }}>
                            {actions}
                        </Box>
                    )}
                    {helpAction}
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={onClose}
                        aria-label="close"
                    >
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Box sx={{ overflow: 'auto', flex: 1 }}>
                {children}
            </Box>
        </Dialog>
    );
};

export default FullScreenDialog;
